export default __webpack_public_path__ + "static/media/Franklin-Gothic-book-normal.720e3daf.woff";